
export const NAME_REDUCER = 'gallery';

export const PREFIX_ACTIONS = 'gallery_feature_';


export const PATH_LOADING = {
  getData: `loading.${NAME_REDUCER}.getData`,
};
